import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Pencil, Trash2 } from "lucide-react";
import html2pdf from "html2pdf.js";
import { useNavigate, useParams } from "react-router-dom";

export default function Measurement() {
  const {
    register,
    // handleSubmit,
    watch,
    reset,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: {
      client_name: "",
      mobile: "",
      address: "",
      measurementtable: [],
    },
  });
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      // Fetch data by id using POST method
      fetch("https://webadmin.naturx.co.in/naturx_api/api/searchclient", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ client_id: id }),
      })
        .then((res) => {
          if (!res.ok) {
            throw new Error("Network response was not ok");
          }
          return res.json();
        })
        .then((data) => {
          if (data) {
            reset({
              client_id: data.data?.client_id || "",
              client_name: data.data?.client_name || "",
              mobile: data.data?.mobile || "",
              address: data.data?.address || "",
              measurementtable: data.data?.measurementtable || [],
              architect_name: data.data?.architect_name || "",
              manager_name: data.data?.manager_name || "",
              lastupdateman_name: data.data?.lastupdatemanager_name || "",
              google_address_link: data.data?.google_address_link || "",
              google_chat_link: data.data?.google_chat_link || "",
            });
            setMeasurementTableData(data.data.measurementtable || []);
            setmainproduct(data.data.mainproduct || []);
            if (Array.isArray(data.data.imagesForCurrentProduct)) {
              setImageUrls(data.data.imagesForCurrentProduct);
            }
          }
        })
        .catch((error) => {
          console.error("API fetch error:", error);
          alert("Failed to fetch measurement data");
          navigate("/measurementTabale");
        });
    }
  }, [id]);

  const [isMainModalOpen, setIsMainModalOpen] = useState(false);
  const [isExtraModalOpen, setIsExtraModalOpen] = useState(false);

  const [measurementtableData, setMeasurementTableData] = useState([]);
  const [image_urls, setImageUrls] = useState([]);
  const [product_name, setproduct_name] = useState("");

  const [mainproduct, setmainproduct] = useState([]); // array of product rows
  const [editingIndex, setEditingIndex] = useState(null); // row edit (modal)
  const [editingProductIndex, setEditingProductIndex] = useState(null); // index in mainproduct

  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [areaToDelete, setAreaToDelete] = useState(null);

  const measurementtable = watch("measurementtable");

  // // Load saved
  // useEffect(() => {
  //   try {
  //     const saved = localStorage.getItem("measurementData");
  //     if (saved) {
  //       const parsed = JSON.parse(saved);
  //       reset({
  //         client_name: parsed.client_name || "",
  //         mobile: parsed.mobile || "",
  //         address: parsed.address || "",
  //         measurementtable: parsed.measurementtable || [],
  //       });
  //       setMeasurementTableData(parsed.measurementtable || []);
  //       setmainproduct(parsed.mainproduct || []);
  //       if (Array.isArray(parsed.imagesForCurrentProduct)) {
  //         setImageUrls(parsed.imagesForCurrentProduct);
  //       }
  //     }
  //   } catch (e) {
  //     console.error("LOAD error:", e);
  //   }
  // }, [reset]);

  // keep RHF synced
  useEffect(() => {
    setValue("measurementtable", measurementtableData, {
      shouldValidate: true,
      shouldDirty: true,
    });
  }, [measurementtableData, setValue]);

  const calculateSqft = (hf, hi, wf, wi, qty) => {
    const hIn = (parseFloat(hf) || 0) * 12 + (parseFloat(hi) || 0);
    const wIn = (parseFloat(wf) || 0) * 12 + (parseFloat(wi) || 0);
    const sqft = (hIn * wIn * (parseFloat(qty) || 1)) / 144;
    return sqft.toFixed(2);
  };

  const calculateMainTotalSqft = () => {
    const table = watch("measurementtable") || [];
    return table
      .filter((r) => r.type === "main")
      .reduce((t, r) => t + parseFloat(r.sqft || 0), 0)
      .toFixed(2);
  };

  const calculateExtraTotalSqft = () => {
    const table = watch("measurementtable") || [];
    return table
      .filter((r) => r.type === "extra")
      .reduce((t, r) => t + parseFloat(r.sqft || 0), 0)
      .toFixed(2);
  };

  const calculateAreaTotalSqft = () => {
    const main = parseFloat(calculateMainTotalSqft());
    const extra = parseFloat(calculateExtraTotalSqft());
    return (main - extra).toFixed(2);
  };

  const addMeasurementToTable = (data, type) => {
    let newRow = null;

    if (
      type === "main" &&
      data.area_name &&
      (data.heightFeet || data.heightInch) &&
      (data.widthFeet || data.widthInch)
    ) {
      newRow = {
        area_name: data.area_name,
        height: `${data.heightFeet || 0}' ${data.heightInch || 0}"`,
        width: `${data.widthFeet || 0}' ${data.widthInch || 0}"`,
        qty: data.qty || 1,
        sqft: calculateSqft(
          data.heightFeet,
          data.heightInch,
          data.widthFeet,
          data.widthInch,
          data.qty
        ),
        type: "main",
      };
    } else if (
      type === "extra" &&
      data.area_name &&
      (data.extraHeightFeet || data.extraHeightInch) &&
      (data.extraWidthFeet || data.extraWidthInch)
    ) {
      newRow = {
        area_name: data.area_name,
        height: `${data.extraHeightFeet || 0}' ${data.extraHeightInch || 0}"`,
        width: `${data.extraWidthFeet || 0}' ${data.extraWidthInch || 0}"`,
        qty: data.extraQty || 1,
        sqft: calculateSqft(
          data.extraHeightFeet,
          data.extraHeightInch,
          data.extraWidthFeet,
          data.extraWidthInch,
          data.extraQty
        ),
        type: "extra",
      };
    }

    if (newRow) {
      const current = watch("measurementtable") || [];
      const updated =
        editingIndex !== null
          ? current.map((row, i) => (i === editingIndex ? newRow : row))
          : [...current, newRow];

      setMeasurementTableData(updated);
      setValue("measurementtable", updated, {
        shouldValidate: true,
        shouldDirty: true,
      });

      setEditingIndex(null);
      reset({
        area_name: "",
        heightFeet: "",
        heightInch: "",
        widthFeet: "",
        widthInch: "",
        qty: "",
        area_name: "",
        extraHeightFeet: "",
        extraHeightInch: "",
        extraWidthFeet: "",
        extraWidthInch: "",
        extraQty: "",
      });
    }
  };

  const removeMeasurementFromTable = (index) => {
    const current = watch("measurementtable") || [];
    const updated = current.filter((_, i) => i !== index);
    setMeasurementTableData(updated);
    setValue("measurementtable", updated, {
      shouldValidate: true,
      shouldDirty: true,
    });
  };

  const handleEditMeasurement = (index) => {
    const table = watch("measurementtable") || [];
    const row = table[index];
    if (!row) return;

    if (row.type === "main") {
      setValue("area_name", row.area_name);
      setValue("heightFeet", row.height.split("'")[0].trim());
      setValue(
        "heightInch",
        row.height.split('"')[0].split("'")[1]?.trim() || ""
      );
      setValue("widthFeet", row.width.split("'")[0].trim());
      setValue(
        "widthInch",
        row.width.split('"')[0].split("'")[1]?.trim() || ""
      );
      setValue("qty", row.qty);
      setIsMainModalOpen(true);
    } else {
      setValue("area_name", row.area_name);
      setValue("extraHeightFeet", row.height.split("'")[0].trim());
      setValue(
        "extraHeightInch",
        row.height.split('"')[0].split("'")[1]?.trim() || ""
      );
      setValue("extraWidthFeet", row.width.split("'")[0].trim());
      setValue(
        "extraWidthInch",
        row.width.split('"')[0].split("'")[1]?.trim() || ""
      );
      setValue("extraQty", row.qty);
      setIsExtraModalOpen(true);
    }
    setEditingIndex(index);
  };

  const handleCancelEdit = () => {
    setEditingIndex(null);
    setIsMainModalOpen(false);
    setIsExtraModalOpen(false);
    setValue("area_name", "");
    setValue("heightFeet", "");
    setValue("heightInch", "");
    setValue("widthFeet", "");
    setValue("widthInch", "");
    setValue("qty", "");
    setValue("area_name", "");
    setValue("extraHeightFeet", "");
    setValue("extraHeightInch", "");
    setValue("extraWidthFeet", "");
    setValue("extraWidthInch", "");
    setValue("extraQty", "");
  };

  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    const promises = files.map(
      (file) =>
        new Promise((resolve) => {
          const reader = new FileReader();
          reader.onload = (ev) => resolve(String(ev.target?.result || ""));
          reader.readAsDataURL(file);
        })
    );
    Promise.all(promises).then((imgs) =>
      setImageUrls((prev) => [...prev, ...imgs])
    );
  };

  // const saveToLocalStorage = (data) => {
  //   try {
  //     const currentTable = watch("measurementtable") || [];
  //     const payload = {
  //       client_name: data.client_name || "",
  //       mobile: data.mobile || "",
  //       address: data.address || "",
  //       measurementtable: currentTable,
  //       mainproduct,
  //       imagesForCurrentProduct: image_urls,
  //       savedAt: new Date().toISOString(),
  //     };
  //     localStorage.setItem("measurementData", JSON.stringify(payload));
  //     alert("Saved to localStorage");
  //   } catch (e) {
  //     console.error("SAVE error:", e);
  //     alert("Local save failed");
  //   }
  // };

  const onSubmit = async (data) => {
    try {
      // Extract only base64 strings from image_urls for each product
      const updatedMainProduct = mainproduct?.map((product) => {
        const base64ImageUrls = product.image_urls
          ? product.image_urls.map((img) =>
              typeof img === "string" ? img : img.image_urls
            )
          : [];
        return { ...product, image_urls: base64ImageUrls };
      });

      const currentTable = watch("measurementtable") || [];

      const payload = {
        client_id: id || undefined,
        client_name: data.client_name || "",
        mobile: data.mobile || "",
        address: data.address || "",
        architect_name: data.architect_name || "",
        manager_name: data.manager_name || "",
        lastupdatemanager_name: data.lastupdatemanager_name || "",
        google_address_link: data.google_address_link || "",
        google_chat_link: data.google_chat_link || "",
        company_id: 2, // Assuming static for now
        measurementtable: currentTable,
        mainproduct: updatedMainProduct || [],
        savedAt: new Date().toISOString(),
      };


      // Send data to API
      const response = await fetch(
        "https://webadmin.naturx.co.in/naturx_api/api/measurements/storeorupdate",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Add other headers if required (e.g., Authorization)
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      alert("Data saved to API successfully!");
    } catch (error) {
      console.error("API Error:", error);
      alert("Failed to save to API");
    }
  };

  // ===== PRODUCT LOGIC =====
  const startEditProduct = (index) => {
    const p = mainproduct[index];
    if (!p) return;
    setEditingProductIndex(index);
    setproduct_name(p.product_name);
    setImageUrls(p.image_urls || []);
    setMeasurementTableData(p.measurementtable || []);
  };

  const clearCurrentProductDraft = () => {
    setproduct_name("");
    setImageUrls([]);
    setMeasurementTableData([]);
    setValue("measurementtable", [], {
      shouldDirty: true,
      shouldValidate: true,
    });
    setEditingProductIndex(null);
  };

  // "Add new" OR "Save changes" with single toolbar button
  const addOrUpdateProductViaToolbar = () => {
    const hasMeasurements = (watch("measurementtable") || []).length > 0;
    if (!product_name.trim()) {
      alert("Please enter Product Name.");
      return;
    }
    if (!hasMeasurements) {
      alert("Add at least one measurement first.");
      return;
    }

    const productPayload = {
      id:
        editingProductIndex !== null
          ? mainproduct[editingProductIndex]?.id
          : undefined,
      product_name,
      main_total_sqft: calculateMainTotalSqft(),
      extra_total_sqft: calculateExtraTotalSqft(),
      area_total_sqft: calculateAreaTotalSqft(),
      image_urls: [...image_urls],
      measurementtable: [...(watch("measurementtable") || [])],
    };

    if (editingProductIndex !== null) {
      const copy = [...mainproduct];
      copy[editingProductIndex] = productPayload;
      setmainproduct(copy);
      setEditingProductIndex(null);
    } else {
      setmainproduct((prev) => [...prev, productPayload]);
    }
    clearCurrentProductDraft();
  };

  const requestDeleteProduct = (index) => {
    setAreaToDelete(index);
    setShowDeleteConfirm(true);
  };
  const confirmDeleteMainArea = () => {
    if (areaToDelete === null) return;
    setmainproduct((prev) => prev.filter((_, i) => i !== areaToDelete));
    setShowDeleteConfirm(false);
    setAreaToDelete(null);
    if (editingProductIndex === areaToDelete) {
      setEditingProductIndex(null);
      clearCurrentProductDraft();
    }
  };

  // ---------- PRINT HELPERS ----------
  const safe = (v) =>
    String(v == null ? "" : v)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");

  // wrap images in images-grid and ensure thumbs have class for page-break avoidance
  const buildImagesHtml = (urls = []) =>
    urls.length
      ? `<div class="images-grid">
        ${urls
          .map(
            (u) => `
            <div class="thumb">
              <img src="${u.image_urls || u}" alt="img" class="thumb-img" />
            </div>
          `
          )
          .join("")}
      </div>`
      : `<div class="text-muted">No images uploaded</div>`;

  // measurement rows (these are the main rows that can be split)
  const buildMeasurementRowsHtml = (rows = []) =>
    rows
      .map(
        (r) => `
          <tr class="row-avoid">
            <td>${safe(r.area_name)}</td>
            <td>${safe(r.height)}</td>
            <td>${safe(r.width)}</td>
            <td>${safe(r.qty)}</td>
            <td>${safe(r.sqft)}</td>
            <td>
              <span class="pill ${
                r.type === "extra" ? "pill-danger" : "pill-success"
              }">
                ${r.type === "extra" ? "Minus" : "Main"}
              </span>
            </td>
          </tr>`
      )
      .join("");

  // products summary: put totals inside <tfoot class="no-break"> so totals don't split
  const buildProductsSummaryHtml = (products = []) => {
    const sum = (arr, key) =>
      arr.reduce((t, p) => t + parseFloat(p?.[key] || 0), 0);
    const totalMain = sum(products, "main_total_sqft").toFixed(2);
    const totalExtra = sum(products, "extra_total_sqft").toFixed(2);
    const totalArea = sum(products, "area_total_sqft").toFixed(2);

    return products.length
      ? `<table class="summary-table">
          <thead>
            <tr>
              <th>Product Name</th>
              <th style="text-align:right">Main SQFT</th>
              <th style="text-align:right">Minus SQFT</th>
              <th style="text-align:right">Area SQFT (Main - Extra)</th>
            </tr>
          </thead>
          <tbody>
            ${products
              .map(
                (p) => `
                <tr class="row-avoid">
                  <td>${safe(p.product_name)}</td>
                  <td style="text-align:right">${safe(p.main_total_sqft)}</td>
                  <td style="text-align:right">${safe(p.extra_total_sqft)}</td>
                  <td style="text-align:right">${safe(p.area_total_sqft)}</td>
                </tr>`
              )
              .join("")}
          </tbody>
          <tfoot class="no-break">
            <tr class="totals">
              <td style="text-align:right;font-weight:700">Totals</td>
              <td style="text-align:right;font-weight:700">${totalMain}</td>
              <td style="text-align:right;font-weight:700">${totalExtra}</td>
              <td style="text-align:right;font-weight:700">${totalArea}</td>
            </tr>
          </tfoot>
        </table>`
      : `<div class="text-muted">No products yet.</div>`;
  };

  // each product becomes a product-block to avoid internal page breaks.
  // important: measurementtable go in normal tbody, totals go in a separate tbody.no-break so totals stay with prior rows
  const buildPerProductBlocksHtml = (products = []) =>
    products
      .map(
        (p, i) => `
          <section class="product-block">
            <h3 style="margin:8px 0;">${i + 1}. ${safe(p.product_name)}</h3>
            ${buildImagesHtml(p.image_urls)}
            <div style="height:8px"></div>
            <table class="table product-table">
              <thead>
                <tr>
                  <th>Area Name</th>
                  <th>Height</th>
                  <th>Width</th>
                  <th>Qty</th>
                  <th>SQFT</th>
                  <th>Type</th>
                </tr>
              </thead>
              <tbody>
                ${buildMeasurementRowsHtml(p.measurementtable)}
              </tbody>
              <tbody class="no-break">
                <tr class="totals">
                  <td colspan="4">Main Total SQFT</td>
                  <td>${safe(p.main_total_sqft)}</td>
                  <td></td>
                </tr>
                <tr class="totals">
                  <td colspan="4">Minus Total SQFT</td>
                  <td>${safe(p.extra_total_sqft)}</td>
                  <td></td>
                </tr>
                <tr class="totals">
                  <td colspan="4">Area Total SQFT (Main - Minus)</td>
                  <td>${safe(p.area_total_sqft)}</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </section>`
      )
      .join("");

  // ---- NEW: Company header HTML builder for PDF ----
  const buildCompanyHeaderHtml = (quotationNumberValue) => {
    return `
      <div style="border-bottom:2px solid #111;padding-bottom:12px;margin-bottom:16px;display:flex;justify-content:space-between;align-items:flex-start;">
        <div style="display:flex;gap:16px;align-items:flex-start;max-width:66%;">
          <div style="width:150px;height:64px;display:flex;align-items:center;justify-content:center;marginTop:400px;">
            <img src="https://www.naturx.co/static/media/logo03132025-removebg.26e6129fc4a3c20d558c.png" 
                 alt="NaturX Logo" style="max-width:100%;max-height:100%;object-fit:contain;width:140px;height:80px;" />
          </div>
          <div style="font-family: Arial, Helvetica, sans-serif;">
            <h1 style="font-size:20px;margin:0 0 6px 0;">NaturX Colour Textures</h1>
            <div style="font-size:12px;color:#4b5563;line-height:1.4;">
              <p style="margin:0;">SHOP 10, MEHTA APARTMENT, JUNA MOTOR STAND CHOWK,</p>
              <p style="margin:0;">PADAMJEE RD, BHAWANI PETH,</p>
              <p style="margin:0;">PUNE-411042, MAHARASHTRA</p>
              <p style="margin:0;">Phone: +91 9998852256 | Email: info.naturx@gmail.com</p>
              <p style="margin:0;">GST: 27AAXFN8702H1ZP</p>
            </div>
          </div>
        </div>

        <div style="text-align:right;">
          <div style="border:2px solid #1f2937;padding:12px 16px;display:inline-block;font-family: Arial, Helvetica, sans-serif;">
            <h2 style="font-size:18px;margin:0 0 4px 0;">Measurement NO</h2>
            <p style="font-size:14px;margin:0;">#${safe(
              quotationNumberValue || ""
            )}</p>
          </div>
        </div>
      </div>
    `;
  };

  // ---------- PRINT (iframe, mobile-friendly) ----------
  const handlePrint = () => {
    const form = getValues();
    const client_name = safe(form.client_name);
    const mobile = safe(form.mobile);
    const address = safe(form.address);
    const today = new Date().toLocaleString();

    const draftRows = watch("measurementtable") || [];
    const hasDraft =
      draftRows.length > 0 && !editingProductIndex && !product_name;

    const draftBlock = hasDraft
      ? `
    <section class="product-block">
      <h2 style="margin:6px 0 8px 0;">Current Draft (Not yet saved as Product)</h2>
      ${image_urls && image_urls.length ? buildImagesHtml(image_urls) : ""}
      <table class="table product-table" style="margin-top:12px;">
        <thead>
          <tr>
            <th>Area Name</th>
            <th>Height</th>
            <th>Width</th>
            <th>Qty</th>
            <th>SQFT</th>
            <th>Type</th>
          </tr>
        </thead>
        <tbody>
          ${buildMeasurementRowsHtml(draftRows)}
        </tbody>
        <tbody class="no-break">
          <tr class="totals">
            <td colspan="4">Main Total SQFT</td>
            <td>${safe(calculateMainTotalSqft())}</td>
            <td></td>
          </tr>
          <tr class="totals">
            <td colspan="4">Minus Total SQFT</td>
            <td>${safe(calculateExtraTotalSqft())}</td>
            <td></td>
          </tr>
          <tr class="totals">
            <td colspan="4">Area Total SQFT (Main - Minus )</td>
            <td>${safe(calculateAreaTotalSqft())}</td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </section>`
      : "";

    const html = `
    <html>
    <head>
      <meta charset="utf-8"/>
      <meta name="viewport" content="width=device-width,initial-scale=1"/>
      <link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet">
      <style>
        body { font-family: Arial, Helvetica, sans-serif; color: #111; }
        table { border-collapse: collapse; width: 100%; }
        th, td { border: 1px solid #e5e7eb; padding: 8px; text-align: left; font-size: 12px; vertical-align: middle; }
        .card { margin-bottom: 16px; }
        .table { width: 100%; }
        img { max-width:100%; height:auto; display:block; }

        /* preserve groupings: avoid breaking inside product blocks / totals */
        .product-block, .no-break, .thumb, .thumb-img, .product-table .totals, .summary-table tfoot {
          page-break-inside: avoid;
          break-inside: avoid;
          -webkit-column-break-inside: avoid;
          -moz-column-break-inside: avoid;
        }

        /* prevent breaking individual table rows if possible */
        .row-avoid, tr {
          page-break-inside: avoid;
          break-inside: avoid;
        }

        /* images grid layout for prints (slightly smaller thumbnails to reduce push) */
        .images-grid { display:flex; flex-wrap:wrap; gap:8px; margin:6px 0 12px 0; }
        .thumb { width: calc(25% - 8px); border-radius: 6px; overflow:hidden; }
        .thumb-img { width:100%; height:auto; display:block; border-radius:6px; }

        thead { display: table-header-group; } /* repeat headers */
        tfoot { display: table-footer-group; }

        .totals td { font-weight:700; background:#f9fafb; }
        .pill-success { background:#ecfdf5; color:#065f46; padding:4px 8px; border-radius:4px; }
        .pill-danger { background:#fff1f2; color:#7f1d1d; padding:4px 8px; border-radius:4px; }

        /* small adjustments to reduce forced page breaks */
        body, .p-6 { margin: 0; padding: 6px; }
      </style>
    </head>
    <body class="p-6 text-gray-800">
      ${buildCompanyHeaderHtml(quotationNumber)}
      <h1 style="text-align:center;margin:8px 0 18px 0;font-size:20px;font-weight:700">Measurement Report</h1>

      <div style="margin-bottom:12px;">
        <p><strong>Client:</strong> ${client_name} | <strong>Mobile:</strong> ${mobile}</p>
        <p><strong>Address:</strong> ${address}</p>
        <p style="color:#6b7280;font-size:12px">Printed: ${today}</p>
      </div>

      <section class="product-block" style="margin-bottom:12px;">
        <h2 style="margin:0 0 8px 0;font-size:16px;">Products Summary</h2>
        ${buildProductsSummaryHtml(mainproduct)}
      </section>

      <div class="products-list">
        ${buildPerProductBlocksHtml(mainproduct)}
      </div>

      ${draftBlock}
    </body>
    </html>
  `;

    // PDF Options - include pagebreak fallback and slightly reduced margin
    const opt = {
      margin: 0.35,
      filename: "measurement-report.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
      pagebreak: { mode: ["css", "legacy"] },
    };

    html2pdf().set(opt).from(html).save();
  };

  // ---------- UI bits ----------
  const Modal = ({ isOpen, onClose, title, children }) => {
    if (!isOpen) return null;
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 print:hidden">
        <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-semibold">{title}</h2>
            <button
              onClick={onClose}
              className="text-gray-500 hover:text-gray-700"
            >
              &times;
            </button>
          </div>
          {children}
        </div>
      </div>
    );
  };

  const ProductPreviewTable = () => {
    const renderThumbs = (urls = []) => {
      if (!urls.length)
        return <span className="text-sm text-gray-500">No images</span>;
      const maxThumbs = 4;
      const thumbs = urls.slice(0, maxThumbs);
      const remaining = Math.max(0, urls.length - maxThumbs);
      return (
        <div className="flex items-center gap-2 flex-wrap">
          {thumbs.map((u, i) => (
            <img
              key={i}
              src={u.image_urls || u}
              alt={`Img ${i + 1}`}
              className="w-10 h-10 object-cover rounded border border-gray-300"
            />
          ))}
          {remaining > 0 && (
            <span className="text-xs px-2 py-1 rounded bg-gray-100 text-gray-700">
              +{remaining} more
            </span>
          )}
        </div>
      );
    };

    const grandArea = mainproduct
      .reduce((sum, p) => sum + parseFloat(p.area_total_sqft || 0), 0)
      .toFixed(2);

    const grandMain = mainproduct
      .reduce((sum, p) => sum + parseFloat(p.main_total_sqft || 0), 0)
      .toFixed(2);

    const grandExtra = mainproduct
      .reduce((sum, p) => sum + parseFloat(p.extra_total_sqft || 0), 0)
      .toFixed(2);

    return (
      <div className="overflow-x-auto bg-white border border-gray-200 rounded-lg">
        <table className="w-full min-w-[720px] text-left">
          <thead className="bg-gray-50">
            <tr>
              <th className="p-3 font-medium text-gray-700">Product Name</th>
              <th className="p-3 font-medium text-gray-700">Main SQFT</th>
              <th className="p-3 font-medium text-gray-700">Minus SQFT</th>
              <th className="p-3 font-medium text-gray-700">
                Area SQFT (Main - Minus)
              </th>
              <th className="p-3 font-medium text-gray-700">Images</th>
              <th className="p-3 font-medium text-gray-700">Action</th>
            </tr>
          </thead>
          <tbody>
            {mainproduct.map((p, idx) => (
              <tr key={p.id || idx} className="align-top hover:bg-gray-50">
                <td className="p-3 border-t border-gray-200">
                  {p.product_name}
                </td>
                <td className="p-3 border-t border-gray-200">
                  {p.main_total_sqft}
                </td>
                <td className="p-3 border-t border-gray-200">
                  {p.extra_total_sqft}
                </td>
                <td className="p-3 border-t border-gray-200">
                  {p.area_total_sqft}
                </td>
                <td className="p-3 border-t border-gray-200">
                  {renderThumbs(p.image_urls)}
                </td>
                <td className="p-3 border-t border-gray-200">
                  <div className="flex flex-wrap gap-2">
                    <button
                      type="button"
                      onClick={() => startEditProduct(idx)}
                      className="px-3 py-1 rounded-lg text-white bg-green-600 hover:bg-green-700 transition-colors"
                      title="Edit this product"
                    >
                      Edit
                    </button>
                    <button
                      type="button"
                      onClick={() => requestDeleteProduct(idx)}
                      className="px-3 py-1 rounded-lg text-white bg-red-500 hover:bg-red-600 transition-colors"
                      title="Delete this product"
                    >
                      Delete
                    </button>
                  </div>
                </td>
              </tr>
            ))}

            {mainproduct.length > 0 && (
              <>
                <tr className="bg-gray-100 font-bold">
                  <td className="p-3 border-t border-gray-300 text-right">
                    Totals
                  </td>
                  <td className="p-3 border-t border-gray-300">{grandMain}</td>
                  <td className="p-3 border-t border-gray-300">{grandExtra}</td>
                  <td className="p-3 border-t border-gray-300">{grandArea}</td>
                  <td className="p-3 border-t border-gray-300"></td>
                  <td className="p-3 border-t border-gray-300"></td>
                </tr>
              </>
            )}
          </tbody>
        </table>
      </div>
    );
  };

  const ConfirmationDialog = ({ isOpen, onClose, onConfirm, message }) => {
    if (!isOpen) return null;
    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 print:hidden">
        <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-sm">
          <p className="text-gray-800 mb-4">{message}</p>
          <div className="flex justify-end space-x-4">
            <button
              onClick={onClose}
              className="px-4 py-2 border border-gray-300 rounded-lg"
            >
              Cancel
            </button>
            <button
              onClick={onConfirm}
              className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600"
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    );
  };
  const quotationNumber = `M_No-${Date.now().toString().slice(-6)}`;

  // ---------- RENDER ----------
  return (
    <div className="mx-auto w-full   sm:p-2 lg:p-8 bg-white min-h-screen">
      <div className="bg-gray-50 rounded-lg shadow-lg p-6 sm:p-2">
        <h1 className="text-2xl font-bold text-gray-800 mb-6 border-b pb-4 mt-12">
          Measurement Masters
        </h1>
        <div
          className={`hidden print:block border-b-2 border-gray-800 pb-4 mb-6`}
        >
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
            }}
          >
            <tbody>
              <tr>
                {/* Company Details Section */}
                <td
                  style={{
                    width: "66.666667%",
                    paddingRight: "16px",
                    verticalAlign: "top",
                  }}
                >
                  <table style={{ width: "100%" }}>
                    <tbody>
                      <tr>
                        <td
                          style={{
                            width: "80px",
                            verticalAlign: "center",
                            paddingRight: "16px",
                            paddingBottom: "16px",
                          }}
                        >
                          {/* Logo Cell */}
                          <div
                            style={{
                              width: "150px",
                              height: "64px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              marginTop: "400px",
                            }}
                          >
                            <img
                              src="https://www.naturx.co/static/media/logo03132025-removebg.26e6129fc4a3c20d558c.png"
                              alt="NaturX Logo"
                              style={{
                                maxWidth: "100%",
                                maxHeight: "100%",
                                objectFit: "contain",
                                width: "140px",
                                height: "80px",
                              }}
                            />
                          </div>
                        </td>
                        <td style={{ verticalAlign: "top" }}>
                          {/* Company Name and Details */}
                          <div>
                            <h1
                              style={{
                                fontSize: "24px",
                                fontWeight: "bold",
                                color: "#1f2937",
                                lineHeight: "1.25",
                                marginBottom: "12px",
                                margin: "0 0 12px 0",
                              }}
                            >
                              NaturX Colour Textures
                            </h1>
                            <div
                              style={{
                                fontSize: "12px",
                                color: "#4b5563",
                                lineHeight: "1.5",
                              }}
                            >
                              <p style={{ margin: "4px 0" }}>
                                SHOP 10,MEHTA APARTMENT,JUNA MOTOR STAND CHOWK,
                              </p>
                              <p style={{ margin: "4px 0" }}>
                                PADAMJEE RD , BHAWANI PETH,
                              </p>
                              <p style={{ margin: "4px 0" }}>
                                PUNE-411042 , MAHARASHTRA
                              </p>
                              <p style={{ margin: "4px 0" }}>
                                Phone: +91 9998852256 | Email:
                                info.naturx@gmail.com
                              </p>
                              <p style={{ margin: "4px 0" }}>
                                GST: 27AAXFN8702H1ZP
                              </p>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>

                {/* Quotation Number Section */}
                <td
                  style={{
                    width: "20.333333%",
                    verticalAlign: "top",
                    textAlign: "right",
                  }}
                >
                  <div
                    style={{
                      border: "2px solid #1f2937",
                      padding: "12px 16px",
                      display: "inline-block",
                    }}
                  >
                    <h2
                      style={{
                        fontSize: "20px",
                        fontWeight: "600",
                        color: "#1f2937",
                        margin: "0 0 4px 0",
                      }}
                    >
                      QUOTATION
                    </h2>
                    <p
                      style={{
                        fontSize: "14px",
                        color: "#4b5563",
                        margin: "0",
                      }}
                    >
                      #{quotationNumber}
                    </p>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="space-y-8">
          {/* Client */}
          <div className="bg-white p-6 rounded-lg border border-gray-200">
            <h2 className="text-xl font-semibold text-gray-700 mb-4">
              Client Section
            </h2>
            <div className="grid gap-4 md:grid-cols-2">
              <div>
                <label className="block text-sm font-medium text-gray-600 mb-2">
                  Client Name
                </label>
                <input
                  type="text"
                  {...register("client_name", {
                    required: "Client name is required",
                  })}
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Enter client name"
                />
                {errors.client_name && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.client_name.message}
                  </p>
                )}
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600 mb-2">
                  Architect name
                </label>
                <input
                  type="text"
                  {...register("architect_name", {
                    required: "Architect name is required",
                  })}
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Enter Architect name"
                />
                {errors.architect_name && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.architect_name.message}
                  </p>
                )}
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600 mb-2">
                  Manager name
                </label>
                <input
                  type="text"
                  {...register("manager_name", {
                    required: "Manager name is required",
                  })}
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Enter Manager name"
                />
                {errors.manager_name && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.manager_name.message}
                  </p>
                )}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-600 mb-2">
                  Mobile Number
                </label>
                <input
                  type="tel"
                  {...register("mobile", {
                    required: "Mobile number is required",
                  })}
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Enter mobile number"
                />
                {errors.mobile && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.mobile.message}
                  </p>
                )}
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600 mb-2">
                  Google Chat Link
                </label>
                <input
                  type="text"
                  {...register("google_chat_link", {
                    required: "Google Chat Link is required",
                  })}
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Enter Google Chat Link"
                />
                {errors.google_chat_link && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.google_chat_link.message}
                  </p>
                )}
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600 mb-2">
                  Google Address Link
                </label>
                <input
                  type="text"
                  {...register("google_address_link", {
                    required: "Google Address Link is required",
                  })}
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Enter Google Address Link"
                />
                {errors.google_address_link && (
                  <p className="text-red-500 text-xs mt-1">
                    {errors.google_address_link.message}
                  </p>
                )}
              </div>
            </div>
            <div className="mt-4">
              <label className="block text-sm font-medium text-gray-600 mb-2">
                Address
              </label>
              <textarea
                {...register("address", { required: "Address is required" })}
                rows={3}
                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Enter address"
              />
              {errors.address && (
                <p className="text-red-500 text-xs mt-1">
                  {errors.address.message}
                </p>
              )}
            </div>
          </div>

          {/* Measurement */}
          <div className="bg-white p-6 rounded-lg border border-gray-200">
            <div className="flex flex-wrap items-end justify-between gap-3 mb-4">
              <h2 className="text-xl font-semibold text-gray-700">
                Measurement Detail
              </h2>
              <div className="flex flex-wrap gap-3">
                <button
                  type="button"
                  onClick={() => setIsMainModalOpen(true)}
                  className="px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 transition-colors"
                >
                  Add Main Area
                </button>
                <button
                  type="button"
                  onClick={() => setIsExtraModalOpen(true)}
                  className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors"
                >
                  Add Minus Measurement
                </button>
                <button
                  type="button"
                  onClick={() =>
                    document.getElementById("image-upload")?.click()
                  }
                  className="px-4 py-2 bg-purple-500 text-white rounded-lg hover:bg-purple-600 transition-colors"
                >
                  Add Image
                </button>
                <input
                  id="image-upload"
                  type="file"
                  accept="image/*"
                  multiple
                  style={{ display: "none" }}
                  onChange={handleImageUpload}
                />
              </div>
            </div>

            <div className="mb-3">
              <label className="block text-sm font-medium text-gray-600 mb-2">
                Product Name
              </label>
              <input
                type="text"
                value={product_name}
                onChange={(e) => setproduct_name(e.target.value)}
                className="w-full md:w-1/2 p-2 border border-gray-300 rounded-lg"
                placeholder="Enter Product Name"
              />
            </div>

            {image_urls.length > 0 && (
              <div className="mt-4 flex flex-wrap gap-4">
                {image_urls.map((url, i) => (
                  <img
                    key={i}
                    src={url.image_urls || url}
                    alt={`Uploaded ${i + 1}`}
                    className="max-w-xs max-h-40 rounded-lg border border-gray-300"
                  />
                ))}
              </div>
            )}

            <div className="mt-6">
              <h3 className="text-lg font-medium text-gray-700 mb-4">
                Measurement Table
              </h3>
              <div className="overflow-x-auto">
                <table className="w-full min-w-[720px] border border-gray-300 rounded-lg">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="p-3 text-left border-b border-gray-300 font-medium text-gray-700">
                        Area Name
                      </th>
                      <th className="p-3 text-left border-b border-gray-300 font-medium text-gray-700">
                        Height
                      </th>
                      <th className="p-3 text-left border-b border-gray-300 font-medium text-gray-700">
                        Width
                      </th>
                      <th className="p-3 text-left border-b border-gray-300 font-medium text-gray-700">
                        Qty
                      </th>
                      <th className="p-3 text-left border-b border-gray-300 font-medium text-gray-700">
                        SQFT
                      </th>
                      <th className="p-3 text-left border-b border-gray-300 font-medium text-gray-700">
                        Type
                      </th>
                      <th className="p-3 text-left border-b border-gray-300 font-medium text-gray-700">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {measurementtable?.map((row, index) => (
                      <tr
                        key={index}
                        className={`hover:bg-gray-50 ${
                          row.type === "extra" ? "bg-red-50" : "bg-green-50"
                        }`}
                      >
                        <td className="p-3 border-b border-gray-200">
                          {row.area_name}
                        </td>
                        <td className="p-3 border-b border-gray-200">
                          {row.height}
                        </td>
                        <td className="p-3 border-b border-gray-200">
                          {row.width}
                        </td>
                        <td className="p-3 border-b border-gray-200">
                          {row.qty}
                        </td>
                        <td className="p-3 border-b border-gray-200">
                          {row.sqft}
                        </td>
                        <td className="p-3 border-b border-gray-200">
                          <span
                            className={`px-2 py-1 rounded text-xs font-medium ${
                              row.type === "extra"
                                ? "bg-red-100 text-red-700"
                                : "bg-green-100 text-green-700"
                            }`}
                          >
                            {row.type === "extra" ? "Minus" : "Main"}
                          </span>
                        </td>
                        <td className="p-3 border-b border-gray-200">
                          <div className="flex space-x-2">
                            <button
                              type="button"
                              onClick={() => handleEditMeasurement(index)}
                              className="text-blue-500 hover:text-blue-700"
                            >
                              <Pencil size={18} />
                            </button>
                            <button
                              type="button"
                              onClick={() => removeMeasurementFromTable(index)}
                              className="text-red-500 hover:text-red-700"
                            >
                              <Trash2 size={18} />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}

                    <tr className="bg-gray-100 font-bold">
                      <td className="p-3 border-b border-gray-200" colSpan={4}>
                        Main Total SQFT
                      </td>
                      <td className="p-3 border-b border-gray-200">
                        {calculateMainTotalSqft()}
                      </td>
                      <td className="p-3 border-b border-gray-200"></td>
                      <td className="p-3 border-b border-gray-200"></td>
                    </tr>
                    <tr className="bg-gray-100 font-bold">
                      <td className="p-3 border-b border-gray-200" colSpan={4}>
                        Minus Total SQFT
                      </td>
                      <td className="p-3 border-b border-gray-200">
                        {calculateExtraTotalSqft()}
                      </td>
                      <td className="p-3 border-b border-gray-200"></td>
                      <td className="p-3 border-b border-gray-200"></td>
                    </tr>
                    <tr className="bg-gray-100 font-bold">
                      <td className="p-3 border-b border-gray-200" colSpan={4}>
                        Area Total SQFT (Main - Minus)
                      </td>
                      <td className="p-3 border-b border-gray-200">
                        {calculateAreaTotalSqft()}
                      </td>
                      <td className="p-3 border-b border-gray-200"></td>
                      <td className="p-3 border-b border-gray-200"></td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* Toolbar BEFORE Product Preview */}
              <div className="mt-4 mb-2">
                <button
                  type="button"
                  onClick={addOrUpdateProductViaToolbar}
                  className="px-4 py-2 rounded-lg border border-gray-300 hover:bg-gray-50"
                  title={
                    editingProductIndex !== null
                      ? "Save changes to this product"
                      : "Add current draft as a new product"
                  }
                >
                  {editingProductIndex !== null
                    ? "Save Changes"
                    : "+ New Product"}
                </button>
              </div>

              {/* Product Preview table (all products) */}
              <h3 className="text-lg font-semibold text-gray-800 mb-2">
                Product Preview
              </h3>
              <ProductPreviewTable />
            </div>
          </div>

          {/* Footer */}
          <div className="flex flex-wrap gap-3 justify-end pt-6 border-t print:hidden">
            <button
              type="button"
              className="px-6 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
              onClick={() => {
                reset({
                  client_name: "",
                  mobile: "",
                  address: "",

                  area_name: "",
                  heightFeet: "",
                  heightInch: "",
                  widthFeet: "",
                  widthInch: "",
                  qty: "",
                  area_name: "",
                  extraHeightFeet: "",
                  extraHeightInch: "",
                  extraWidthFeet: "",
                  extraWidthInch: "",
                  extraQty: "",
                });
                setmainproduct([]);
                setMeasurementTableData([]);
                setImageUrls([]);
                setproduct_name("");
                setEditingIndex(null);
                setEditingProductIndex(null);
              }}
            >
              Cancel
            </button>
            <button
              // type="submit"
              onClick={() => onSubmit(getValues())}
              className="px-6 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
            >
              Save Measurement
            </button>
            {/* <button
                type="button"
                onClick={() => saveToLocalStorage(getValues())}
                className="px-6 py-2 border border-blue-500 text-blue-600 rounded-lg hover:bg-blue-50 transition-colors"
                title="Use this only if the blue Save doesn't store"
              >
                Force Save (Fallback)
              </button> */}

            {/* Print Button */}
            <button
              type="button"
              onClick={handlePrint}
              className="px-6 py-2 border border-gray-500 text-gray-800 rounded-lg hover:bg-gray-50 transition-colors"
              title="Print all data in A4 format"
            >
              Print
            </button>
            <button
              type="button"
              onClick={() => navigate("/measurementTabale")}
              className="px-6 py-2 border border-gray-500 text-gray-800 rounded-lg hover:bg-gray-50 transition-colors"
              title="Print all data in A4 format"
            >
              {"<- Back"}
            </button>
          </div>
        </div>
      </div>

      {/* Modals */}
      <Modal
        isOpen={isMainModalOpen}
        onClose={handleCancelEdit}
        title={editingIndex !== null ? "Edit Main Area" : "Add Main Area"}
      >
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-600 mb-2">
              Area Name
            </label>
            <input
              type="text"
              {...register("area_name", { required: "Area name is required" })}
              className="w-full p-3 border border-gray-300 rounded-lg"
              placeholder="Enter area name"
            />
            {errors.area_name && (
              <p className="text-red-500 text-xs mt-1">
                {errors.area_name.message}
              </p>
            )}
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-600 mb-2">
                Height (Feet)
              </label>
              <input
                type="number"
                {...register("heightFeet")}
                className="w-full p-3 border border-gray-300 rounded-lg"
                placeholder="Feet"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-600 mb-2">
                Height (Inch)
              </label>
              <input
                type="number"
                {...register("heightInch")}
                className="w-full p-3 border border-gray-300 rounded-lg"
                placeholder="Inch"
              />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-600 mb-2">
                Width (Feet)
              </label>
              <input
                type="number"
                {...register("widthFeet")}
                className="w-full p-3 border border-gray-300 rounded-lg"
                placeholder="Feet"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-600 mb-2">
                Width (Inch)
              </label>
              <input
                type="number"
                {...register("widthInch")}
                className="w-full p-3 border border-gray-300 rounded-lg"
                placeholder="Inch"
              />
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-600 mb-2">
              Quantity
            </label>
            <input
              type="number"
              {...register("qty")}
              className="w-full p-3 border border-gray-300 rounded-lg"
              placeholder="Quantity"
            />
          </div>
          <div className="flex justify-end space-x-4">
            <button
              type="button"
              onClick={handleCancelEdit}
              className="px-4 py-2 border border-gray-300 rounded-lg"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={() => {
                addMeasurementToTable(watch(), "main");
                handleCancelEdit();
              }}
              className="px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600"
            >
              {editingIndex !== null ? "Update" : "Add"}
            </button>
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={isExtraModalOpen}
        onClose={handleCancelEdit}
        title={
          editingIndex !== null
            ? "Edit Minus Measurement"
            : "Add Minus Measurement"
        }
      >
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-600 mb-2">
              Area Name
            </label>
            <input
              type="text"
              {...register("area_name", {
                required: "Area name is required",
              })}
              className="w-full p-3 border border-gray-300 rounded-lg"
              placeholder="Enter area name"
            />
            {errors.area_name && (
              <p className="text-red-500 text-xs mt-1">
                {errors.area_name.message}
              </p>
            )}
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-600 mb-2">
                Height (Feet)
              </label>
              <input
                type="number"
                {...register("extraHeightFeet")}
                className="w-full p-3 border border-gray-300 rounded-lg"
                placeholder="Feet"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-600 mb-2">
                Height (Inch)
              </label>
              <input
                type="number"
                {...register("extraHeightInch")}
                className="w-full p-3 border border-gray-300 rounded-lg"
                placeholder="Inch"
              />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-600 mb-2">
                Width (Feet)
              </label>
              <input
                type="number"
                {...register("extraWidthFeet")}
                className="w-full p-3 border border-gray-300 rounded-lg"
                placeholder="Feet"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-600 mb-2">
                Width (Inch)
              </label>
              <input
                type="number"
                {...register("extraWidthInch")}
                className="w-full p-3 border border-gray-300 rounded-lg"
                placeholder="Inch"
              />
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-600 mb-2">
              Quantity
            </label>
            <input
              type="number"
              {...register("extraQty")}
              className="w-full p-3 border border-gray-300 rounded-lg"
              placeholder="Quantity"
            />
          </div>
          <div className="flex justify-end space-x-4">
            <button
              type="button"
              onClick={handleCancelEdit}
              className="px-4 py-2 border border-gray-300 rounded-lg"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={() => {
                addMeasurementToTable(watch(), "extra");
                handleCancelEdit();
              }}
              className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600"
            >
              {editingIndex !== null ? "Update" : "Add"}
            </button>
          </div>
        </div>
      </Modal>

      <ConfirmationDialog
        isOpen={showDeleteConfirm}
        onClose={() => setShowDeleteConfirm(false)}
        onConfirm={confirmDeleteMainArea}
        message="Are you sure you want to delete this Product?"
      />
    </div>
  );
}
